// extracted by mini-css-extract-plugin
export default {"delContainer":"CustomerModal_delContainer__ruE6B"};